import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {PageableModel} from "../../common/models/table";
import {FerryHandlingTimeFilters, FerryHandlingTimeModel} from "../models/ferryHandlingTime";
import {AxiosResponse} from "axios";
import {DownloadService} from "../../common/services/downloadService";

export class FerryHandlingTimeService {
    private static baseUrl = apiUrls.reports.ferryHandlingTime;

    public static async generateReport(filters: FerryHandlingTimeFilters): Promise<AxiosResponse<PageableModel<FerryHandlingTimeModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<FerryHandlingTimeModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: FerryHandlingTimeFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";
        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: FerryHandlingTimeFilters) {
        return `arrivalFerryFrom=${filters.arrivalFerryFrom}&arrivalFerryTo=${filters.arrivalFerryTo}` +
            `&departureFerryFrom=${filters.departureFerryFrom}&departureFerryTo=${filters.departureFerryTo}` +
            `&ferryEntityId=${filters.ferryEntityId}&actionType=${filters.actionType}&voyageNo=${filters.voyageNo}`;
    }
}
